import { logger } from '@/services/LoggingService';
import { fetchAllocationAssetIds } from '@/services/portfolio/PortfolioAllocationsService';

export async function fetchAllocatedAssetIdSet(portfolioId: string): Promise<Set<string>> {
  try {
    const ids = await fetchAllocationAssetIds(portfolioId);
    return new Set(ids);
  } catch (error) {
    logger.error('current-allocations', 'Error fetching current allocations', { error });
    return new Set();
  }
}
